<template>
  <div>
    <el-dialog :title="$t('system.modify_pwd')" class="diglog-card" :close-on-click-modal="false" :visible.sync="dialogPwdVisible" width="509px" @close="handleDialogClose">
      <div class="header-line" />
      <div class="section-title">
        {{ $t('system.password_details') }}
      </div>
      <div class="section-tip">
        {{ $t('tips.update_your_password_entering_new_one') }}
      </div>
      <div class="modify-password">
        <el-form ref="form" :model="form" label-width="200px" :rules="rules" label-position="top">
          <el-row>
            <el-col :span="24">
              <el-form-item :label="$t('system.password')" prop="password" required>
                <el-input v-model="form.password" size="small" :placeholder="$t('system.password')" class="input-password" autocomplete="off" clearable show-password />
              </el-form-item>
            </el-col>
          </el-row>
          <br>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogPwdVisible = false">{{ $t('components.cancel') }}</el-button>
          <el-button type="info" class="btn-submit" :disabled="listLoading" @click="submitModifyPwd('form')">{{ $t('components.submit') }}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>

</template>

<script>
import { updateMerchantUserPwd } from '@/api/system/system'
import { cryptoJSAesEncrypt } from '@/utils/encrypt'

export default {
  name: 'ModifyPwdModal',
  data() {
    const checkPasswordLength = (rule, value, callback) => {
      if (value.length < 8 || value.length > 15) {
        return callback(new Error('password must between 8 ~ 15 character'))
      }
      const regex = new RegExp('(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@%*&_])[A-Za-z\\d@%*&_]{8,15}$')
      if (!regex.test(value)) {
        return callback(new Error('Passwords must be between 8 and 15 characters. Must contain and only contain the following: uppercase and lowercase letters, alphabets, and special characters (limited to @%*&_).'))
      }
      return callback()
    }
    return {
      dialogPwdVisible: false,
      listLoading: false,
      form: {
        id: '',
        password: '',
        checkPass: ''
      },
      rules: {
        password: [
          { validator: checkPasswordLength, trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  mounted() {
    this.$bus.off('SHOW_MODIFY_PWD_MODAL')
    this.$bus.on('SHOW_MODIFY_PWD_MODAL', (value) => {
      this.dialogPwdVisible = value[0]
      this.form.email = value[1]
      this.form.password = ''
    })
  },
  methods: {
    submitModifyPwd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.listLoading = true
          const params = {
            email: cryptoJSAesEncrypt(this.form.email),
            password: cryptoJSAesEncrypt(this.form.password)
          }
          updateMerchantUserPwd(params).then(res => {
              this.$message.success('Success')
              this.dialogPwdVisible = false
          }).finally(() => {
            this.listLoading = false
          })
        }
      })
    },
    handleDialogClose() {
      this.$refs['form'].clearValidate()
    }
  }
}
</script>

<style scoped>
.input-password{
  width: 300px;
}
.modify-password{
  /* margin: 0 10px 0 50px; */
}
.dialog-footer{
  text-align: right;
}
</style>
